import type * as React from 'react';
import { useSelector } from 'react-redux';
import { PopoverSelect } from '../../components/PopoverSelect';
import { MobileSelect } from '../../components/MobileSelect';
import { getSiteType } from '../../selectors/siteType';
import { IBaseSelectProps } from '../../types/select';

/* istanbul ignore next */
export function AdaptiveSelect(props: IBaseSelectProps): React.JSX.Element {
  const siteType = useSelector(getSiteType);
  const isTablet = siteType === 'tablet';

  if (isTablet) {
    return <PopoverSelect {...props} />;
  }

  return <MobileSelect {...props} />;
}
